package pl.nickers.match3.ecs

import pl.nickers.match3.SoundEvent
import kotlin.random.Random

internal class MatchDetectionSystem(
    private val random: Random = Random.Default,
    private val catalog: EntityCatalog = EntityCatalog.default(),
    private val pieceSet: PieceSet = PieceSetLoader.default(),
) : BaseSystem() {
    private lateinit var justMovedMapper: ComponentMapper<JustMovedComponent>

    override fun initialize() {
        justMovedMapper = world.mapper()
    }

    override fun processSystem() {
        val board = world.boardState() ?: return
        if (board.phase != GamePhase.RESOLVE || board.currentSubphase != ResolveSubphase.MATCH_DETECT) return
        val preferredSeeds = mutableSetOf<Int>()
        world.getEntitiesForAspect(Aspect.all(JustMovedComponent::class)).forEach { id ->
            preferredSeeds.add(id)
            justMovedMapper.remove(id)
        }

        val groups = findMatchGroups(world, board.width, board.height, pieceSet = pieceSet)
        if (groups.isEmpty()) return

        world.enqueueAudioEvent(SoundEvent.MATCH_DETECTED)
        if (groups.any { it.seedPieceId == PieceIds.COLOURFUL_SWIRL }) {
            world.enqueueAudioEvent(SoundEvent.SWIRL_CLEAR)
        }
        val allMatched = groups.flatMapTo(mutableSetOf()) { it.entities }
        stampMatchNeighbours(world, allMatched, board.width, board.height)
        // E5: matching a cursed ingredient on a Purified Rune cleanses it, restoring its
        // goal credit for this very match — so cleanse before checking for curses.
        world.cleanseCursedOnRunes(allMatched)
        // A match group that still holds a cursed ingredient is *spoiled*: it clears from
        // the board but awards no score and no goal credit for ANY of its items (one bad
        // ingredient ruins the whole line). Spoiling is per-group — a cursed line does not
        // taint a separate clean line resolved in the same pass. Cleansed-on-rune pieces no
        // longer count as cursed here, so their group is clean.
        val scorableMatched = groups
            .filterNot { group -> group.entities.any { world.hasComponent(it, CursedComponent::class) } }
            .flatMapTo(mutableSetOf()) { it.entities }
        val pieceIdCounts = world.countPieceIds(scorableMatched, pieceSet)
        board.score += applyMatchGroups(
            world, groups, board.width, board.height, random, catalog, preferredSeeds,
            pieceSet = pieceSet, scorableEntities = scorableMatched,
        )
        world.decrementGoalsAndCheckWin(pieceIdCounts, board)

        board.didWork = true
    }
}
